import React, { Component } from 'react';

function chk_progress(visitedData, pref) {
  let prog = visitedData[pref].num_visit / visitedData[pref].num_all
  console.log(prog > 0.5);
  if (prog === 1) {
    return 'perfect'
  } else if (prog > 0.5) {
    return 'good'
  } else {
    return 'yet'
  }
}

class ChugokuTop extends Component {
  render() {
    return (
      <div className="Chugoku-top pref">
        <div>山口</div>
        <div>鳥取</div>
        <div>島根</div>
      </div>
    );
  }
}
class ChugokuBot extends Component {
  render() {
    return (
      <div className="Chugoku-bot pref">
        <div>広島</div>
        <div className={chk_progress(this.props.visitedData, '岡山')}>岡山</div>
      </div>
    );
  }
}


class Chugoku extends Component {

  render() {
    return (
      <div className="Chugoku">
        <ChugokuTop />
        <ChugokuBot visitedData={this.props.visitedData}/>
      </div>
    );
  }

}

export default Chugoku;
